import { CButton, CCol, CContainer, CFormLabel, CFormTextarea, CModal, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CModalBody, CModalFooter, CModalHeader, CModalTitle, CRow, CTooltip } from '@coreui/react';
import React, { useEffect, useState } from 'react';
import Graytextarea from '../../components/Graytextarea';
import SaveExtra from '../../services/general/saveExtraData.api';
import { Info, Plus } from 'lucide-react';
import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'

import {
  CFormCheck
} from '@coreui/react';
import AddOrders from './AddOrders';
import { backgroundColor } from '@syncfusion/ej2-richtexteditor/src/rich-text-editor/models/items';
import { useIndexedDB } from '../../context/IndexedContext';
import FetchOrderForAssessment from './fetchOrderForAssessment';
import {
  collectSelectedAssessmentOrderData,
  getSuggestionKey,
  getSuggestionText,
  getTitleKey,
} from '../../utils/assessmentPlanSuggestions';


const ProviderShellAssessment = ({
  setActiveTabPatientInfo,
  saveTreatsShell,
  diagnosisName,
  patientID,
  contentEditable = false,
  isTextInput, isAllotedToProvider, setAddedChangesToAssessment,
  showDataIfNoteIsFollowUp = true,
  showTreatmentAsAccordion,
  patientTreatments, noteStructureRef, imagingTypeList, imaging, MasterDiagnosisData,
  medsRemarks, allLabs, diagnosisAddedPinger, medicationList,
  masterMedications, noteID,
  loggedUserProvider, changesInTreatmentShell, setChangesInTreatmentShell, noteCallType, patientDBData,
  setPatientDBData
}) => {
  const { getAssSuggMasterData, saveOfflineData, getOfflineData, getOpenChartOfflineData, saveOpenChartOfflineData } = useIndexedDB()


  const [showItemsDescriptions, setShowItemsDescriptions] = useState([]);
  const [visible, setVisible] = useState(false);
  const [assessment, setAssessment] = useState('');
  const [freeType, setFreeType] = useState('');
  const [poa, setPoa] = useState('');
  const [assessmentSuggestions, setAssessmentSuggestions] = useState('');
  const [freeModelVisible, setIsFreeModalVisible] = useState(false);
  const [bimsScoreData, setBimsScoreData] = useState({
    score: "",
    date: ""
  })
  const [orderModalVisible, setOrderModalVisible] = useState(false)
  const [activeKey, setActiveKey] = useState(1)
  const [activeKey2, setActiveKey2] = useState(2)
  const [sugesstionsAssessmentsList, setSugesstionsAssessmentsList] = useState([]); //putting the fetched data

  const [assessmentFinalValue, setAssessmentFinalValue] = useState('');

  const [selectedAssessmentSuggestionStrings, setSelectedAssessmentSuggestionString] = useState([]);
  const [selectedPlansSuggestionsStrings, setSelectedPlanSuggestionsStrings] = useState([]);
  const [formattedSelectedPlanSuggestionsStrings, setFormattedSelectedPlanSuggestionsStrings] = useState([]);
  const [selectedPlanSuggestion, setSelectedPlanSuggestion] = useState([]);
   const [ selectedOrder ,setSelectedOrder] = useState([])
  console.log(formattedSelectedPlanSuggestionsStrings, selectedAssessmentSuggestionStrings, selectedPlansSuggestionsStrings, 'selectedPlansSuggestionsStrings=>>>>')
  const [tempText, setTempText] = useState('')
  let count = 0;

  let newAssessment = '';

  const getAncestorTitleKeys = (targetKey, accordions = sugesstionsAssessmentsList) => {
    const ancestors = []

    const visit = (items, path = []) => {
      for (const accordion of Array.isArray(items) ? items : []) {
        const titleKey = getTitleKey(accordion?.id)
        const currentPath = accordion?.id ? [...path, titleKey] : path

        if (titleKey === targetKey) {
          ancestors.push(...path)
          return true
        }

        const suggestions = Array.isArray(accordion?.suggestions?.suggestionName)
          ? accordion.suggestions.suggestionName
          : []

        if (suggestions.some((suggestion) => getSuggestionKey(accordion?.id, suggestion) === targetKey)) {
          ancestors.push(...currentPath.slice(0, -1))
          return true
        }

        if (visit(accordion?.children, currentPath)) {
          return true
        }
      }

      return false
    }

    visit(accordions)
    return ancestors
  }

  const getDisplayAssessmentKeys = (sourceKeys) => {
    const displayKeys = [...new Set(sourceKeys)]

    sourceKeys.forEach((key) => {
      getAncestorTitleKeys(key).forEach((ancestorKey) => {
        if (!displayKeys.includes(ancestorKey)) {
          displayKeys.push(ancestorKey)
        }
      })
    })

    return displayKeys
  }

  useEffect(() => {
    if (noteStructureRef && noteStructureRef.current && noteStructureRef.current?.BIMSScore) {
      const bimsForCognitive = noteStructureRef?.current?.BIMSScore["Cognitive Communication Deficit"]
      setBimsScoreData(bimsForCognitive)
    }
  }, [])

  useEffect(() => {
    const freeTypeData = noteStructureRef?.current?.assessment?.[diagnosisName]?.FreeType
    setFreeType(freeTypeData);
    if (patientTreatments && patientTreatments.length > 0) {
      let treatmentDetails = patientTreatments[noteID || 0];
      console.log("treatments", treatmentDetails, noteID)
      if (!treatmentDetails) {
        treatmentDetails = patientTreatments[0];

      }
      const { data } = treatmentDetails;
      if (!data?.assessment) {
        // noteStructureRef.current = {
        //   ...noteStructureRef.current,
        //   assessment: {
        //     ...noteStructureRef.current.assessment,
        //     [diagnosisName]: {
        //       MobilityAssessment: {},
        //       POA: "",
        //       MorseScore: {},
        //       LabImaging: "",
        //       FreeType: "",
        //       assessmentSuggestions: "",
        //       selfCareAssessment: {}
        //     }
        //   }

        // };

      } else if (data?.assessment && !data?.assessment[diagnosisName]) {
        // noteStructureRef.current = {
        //   ...noteStructureRef.current,
        //   assessment: {
        //     ...noteStructureRef.current.assessment,
        //     [diagnosisName]: {
        //       MobilityAssessment: {},
        //       POA: "",
        //       MorseScore: {},
        //       LabImaging: "",
        //       FreeType: "",
        //       selfCareAssessment: {}
        //     }
        //   }

        // };

        console.log("data=====[][][][][==========>",)
      } else if (data?.assessment && data?.assessment[diagnosisName]) {
        console.log("type of dataq", typeof data.assessment[diagnosisName])
        if (typeof data.assessment[diagnosisName] === 'string') {
          // noteStructureRef.current = {
          //   ...noteStructureRef.current,
          //   assessment: {
          //     ...noteStructureRef.current.assessment,
          //     [diagnosisName]: {
          //       MobilityAssessment: {},
          //       POA: "",
          //       MorseScore: {},
          //       LabImaging: "",
          //       FreeType: "",
          //       selfCareAssessment: {}
          //     }
          //   }

          // };
        }
      }
      let existingAssessment = `${data?.assessment && data?.assessment[diagnosisName]?.LabImaging} ` || "";
      // const existingAssessment = (data?.assessment && data?.assessment[diagnosisName]) || "";

      if (existingAssessment.trim() === "undefined" || existingAssessment === "null") {
        console.log("existingAssessment==========>", existingAssessment)
        existingAssessment = "";
      }
      let freeTypeData = (data?.assessment && data?.assessment[diagnosisName]?.FreeType) || "";
      let assessmentSuggestions = (data?.assessment && data?.assessment[diagnosisName]?.assessmentSuggestions) || "";
      // if (diagnosisName !== 'Falls') {
      //     existingAssessment = (data?.assessment && data?.assessment[diagnosisName]) || "";

      // } else {
      //     existingAssessment = (data?.assessment && data?.assessment[diagnosisName]?.LabImaging) || "";
      // }
      setAssessmentSuggestions(assessmentSuggestions)
      // setFreeType(freeTypeData);
      // newAssessment = existingAssessment || "";
      console.log("existingAssessment", existingAssessment, newAssessment)
    } else {

      // noteStructureRef.current = {
      //   ...noteStructureRef.current,
      //   assessment: {
      //     ...noteStructureRef.current.assessment,
      //     [diagnosisName]: {
      //       MobilityAssessment: {},
      //       POA: "",
      //       MorseScore: {},
      //       LabImaging: "",
      //       FreeType: "",
      //       selfCareAssessment: {}
      //     }
      //   }

      // };
    }

    let allImagingRemarks = null;

    let lastLabsRemarks = [];

    let standingMedicationTemplate = "";

    let lastImaging = imaging && imaging.length > 0 && imaging[imaging.length - 1];

    if (imagingTypeList.length > 0 && lastImaging?.data) {
      const lastImagingImpression = lastImaging.data.impression.toLowerCase();
      const lastImagingPatientSelectedImaging = lastImaging.data.name.toLowerCase();

      const findMatchingImagingMaster = imagingTypeList.find(item =>
        item.Name.toLowerCase() === lastImagingPatientSelectedImaging
      );

      if (findMatchingImagingMaster) {
        let matchingDiagnosisImaging = [];
        for (let keywordDetail of findMatchingImagingMaster.Keywords) {
          const keywordsArray = keywordDetail.keyword
            .split(',')
            .map(keyword => keyword.trim().toLowerCase())
            .filter(keyword => keyword !== '');
          if (keywordsArray.some(item => lastImagingImpression.includes(item?.toLowerCase()))) {
            matchingDiagnosisImaging.push(keywordDetail)
          }
        }
        for (const remarkD of matchingDiagnosisImaging) {
          for (const masterD of MasterDiagnosisData) {
            if (masterD.id === Number(remarkD.diagnosis)) {
              if (diagnosisName.trim() === masterD.Name.trim()) {
                allImagingRemarks = [{
                  ...masterD,
                  ...remarkD,
                  ...lastImaging,
                }]
              }
            }
          }
        }
      }
    }

    if (allLabs.length > 0) {
      const lastLab = allLabs[0] || [];

      const lastLabArrOfLabs = lastLab?.data || [];

      let allMatchingLab = lastLabArrOfLabs.filter(item => {
        const diagnosisLab = item.diagnosis.split(",").filter(item => item !== '');
        return diagnosisLab.some(diagn => diagn.includes(diagnosisName));
      });

      lastLabsRemarks = allMatchingLab.map(item => item.remark).filter(item => item !== '');
    }

    if (lastLabsRemarks.length > 0) {
      const lastLabsRemarksText = lastLabsRemarks.join('\n');


      if (!newAssessment.includes(lastLabsRemarksText)) {
        if (newAssessment !== '') {
          newAssessment += '\n';
        }
        newAssessment += lastLabsRemarksText;
      }
      console.log(lastLabsRemarks, 'added', newAssessment, 'lastLabsRemarks for ', diagnosisName);
    }

    if (allImagingRemarks) {


      if (!newAssessment.includes(allImagingRemarks[allImagingRemarks.length - 1]?.remarks)) {
        if (newAssessment !== '') {
          newAssessment += '\n';
        }
        newAssessment += allImagingRemarks[allImagingRemarks.length - 1]?.remarks; //tunr this off letter
      }

      console.log("Assessment imagging", allImagingRemarks);
      // newAssessment += allImagingRemarks?.remarks; // turn this on

    }

    // if (standingMedicationTemplate && standingMedicationTemplate !== '') {
    //     if (newAssessment !== '') {
    //         newAssessment += '\n\n';
    //     }
    //     newAssessment += standingMedicationTemplate;
    // }

    // if (newAssessment.trim() !== '') {
    //     const existingAssessment = noteStructureRef.current.assessment?.[diagnosisName];

    //     if (existingAssessment !== newAssessment) {
    //         console.log("Assessment Added", newAssessment, count++);

    //         setAssessment(newAssessment);

    //         noteStructureRef.current = {
    //             ...noteStructureRef.current,
    //             assessment: {
    //                 ...noteStructureRef.current.assessment,
    //                 [diagnosisName]: newAssessment,
    //             },
    //         };
    //     } else {
    //         console.log("Duplicate assessment not added");
    //     }
    // }





    // if (newAssessment.trim !== '') {
    //     console.log("diagnosis name ", diagnosisName)
    //     setAssessment(newAssessment);
    //     noteStructureRef.current = {
    //         ...noteStructureRef.current,
    //         assessment: {
    //             ...noteStructureRef.current.assessment,
    //             [diagnosisName]: {
    //                 ...noteStructureRef.current.assessment[diagnosisName] || {
    //                     MobilityAssessment: {},
    //                     POA: "",
    //                     MorseScore: {},
    //                     LabImaging: "",
    //                     FreeType: "",
    //                 },
    //                 LabImaging: newAssessment || '',
    //             }
    //         }
    //     }
    // }


    if (newAssessment.trim() !== '' && newAssessment.trim() !== 'undefined' && newAssessment !== 'null') {
      console.log("diagnosis name ", diagnosisName, newAssessment);
      setAssessment(newAssessment);

      const currentAssessment = noteStructureRef.current.assessment || {};
      const existingDiagnosisData = currentAssessment[diagnosisName] || {
        MobilityAssessment: {},
        POA: "",
        MorseScore: {},
        LabImaging: "",
        FreeType: "",
      };

      noteStructureRef.current = {
        ...noteStructureRef.current,
        assessment: {
          ...currentAssessment,
          [diagnosisName]: {
            ...existingDiagnosisData,
            LabImaging: newAssessment || '',
          }
        }
      };
    }
    // setAssessment(newAssessment);
    // noteStructureRef.current = {
    //     ...noteStructureRef.current,
    //     assessment: {
    //         ...noteStructureRef.current.assessment,
    //         [diagnosisName]: {
    //             ...noteStructureRef.current.assessment[diagnosisName],
    //             LabImaging: newAssessment || '',
    //         }
    //     }
    // };


  }, [imaging, imagingTypeList, diagnosisAddedPinger, allLabs, noteStructureRef]);

  const handleChanges = (e) => {
    const { value } = e.target;
    setFreeType(value);
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment?.[diagnosisName],
          FreeType: value || '',
        }
      }
    };
  };

  const handleAddFreeTypeOfflineAssessment = async (tempText) => {
    try {
      let dataOffline = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()

      if (!dataOffline) dataOffline = {};

      const providerID = loggedUserProvider?.ID;
      const diagnosis = diagnosisName;

      dataOffline[providerID] = dataOffline[providerID] || {};
      dataOffline[providerID][patientID] = dataOffline[providerID][patientID] || {};
      dataOffline[providerID][patientID].saveDraft = true
      dataOffline[providerID][patientID].currentNote = dataOffline[providerID][patientID].currentNote || {};
      dataOffline[providerID][patientID].currentNote.data = dataOffline[providerID][patientID].currentNote.data || {};
      dataOffline[providerID][patientID].currentNote.data.assessment =
        dataOffline[providerID][patientID].currentNote.data.assessment || {};

      dataOffline[providerID][patientID].currentNote.data.assessment[diagnosis] =
        dataOffline[providerID][patientID].currentNote.data.assessment[diagnosis] || {};

      // Set FreeType text
      dataOffline[providerID][patientID].currentNote.data.assessment[diagnosis].FreeType =
        tempText || "";

      console.log("offlineData after adding FreeType:", dataOffline);

      noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(dataOffline) : await saveOfflineData(dataOffline)

    } catch (e) {
      console.log(e);
    }
  };


  const handleSave = () => {

    setFreeType(tempText)
    // Update the noteStructureRef only when saving
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment?.[diagnosisName],
          FreeType: tempText || '',
        },
      },
    }
    handleAddFreeTypeOfflineAssessment(tempText)
    // saveTreatsShell(false)
    setIsFreeModalVisible(false)
    setChangesInTreatmentShell((p) => !p)
  }


  const handlePoaChange = (value) => {
    setPoa(value);
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment?.[diagnosisName],
          POA: value
        }
      }
    };
  }

  const handleLabsChanges = (value) => {
    setAssessment(value);
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment?.[diagnosisName],
          LabImaging: value
        }
      }
    };
  }


  // useEffect(() => {
  //     if (!noteStructureRef.current.assessment) {
  //         noteStructureRef.current.assessment = {};
  //     }

  //     if (!noteStructureRef.current.assessment[diagnosisName]) {
  //         noteStructureRef.current.assessment[diagnosisName] = {};
  //     }

  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         assessment: {
  //             ...noteStructureRef.current.assessment,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.assessment?.[diagnosisName],
  //                 assessmentSuggestions: assessmentSuggestions,
  //             },
  //         },
  //     };
  // }, [assessmentSuggestions]);


  // useEffect(()=>{
  //     // planSuggestion
  //     const assessmentSuggestionAdded = noteStructureRef?.current?.assessment?.[diagnosisName]?.assessmentSuggestions
  //     const planSuggestionAdded = noteStructureRef?.current?.plans?.[diagnosisName]?.planSuggestion;
  //     if(assessmentSuggestionAdded){
  //         const splittedArrayAssessmentSuggestion = assessmentSuggestionAdded.split('\n');
  //         if(splittedArrayAssessmentSuggestion.length > 0){

  //         }
  //         setSelectedAssessmentSuggestionString(splittedArrayAssessmentSuggestion)
  //     }
  //     if(planSuggestionAdded){
  //         const splittedArrayPlan = planSuggestionAdded.split('\n');
  //         setSelectedPlanSuggestionsStrings(splittedArrayPlan)
  //     }
  // },[])


  ///useEffect
  // useEffect(() => {
  //   const assessmentSuggestionAdded =
  //     noteStructureRef?.current?.assessment?.[diagnosisName]?.assessmentSuggestions;
  //   const planSuggestionAdded =
  //     noteStructureRef?.current?.plans?.[diagnosisName]?.planSuggestion;

  //   if (assessmentSuggestionAdded) {
  //     const splittedArrayAssessmentSuggestion = assessmentSuggestionAdded.split("\n").filter(Boolean);
  //     console.log(splittedArrayAssessmentSuggestion, 'splittedArrayAssessmentSuggestion')

  //     if (splittedArrayAssessmentSuggestion.length > 0) {
  //       setSelectedAssessmentSuggestionString(splittedArrayAssessmentSuggestion);

  //       // Recursively search and collect matching plan structures
  //       const collectedPlanSuggestions = [];

  //       const searchAccordions = (accordions) => {
  //         for (const accordion of accordions) {
  //           const suggestions = accordion?.suggestions?.suggestionName || [];

  //           for (const suggestion of suggestions) {
  //             if (splittedArrayAssessmentSuggestion.includes(suggestion.name)) {
  //               const planSuggestions = accordion?.suggestions?.planSuggestions || [];

  //               const matchingPlan = planSuggestions.find(
  //                 (plan) => plan.name === suggestion.name
  //               );

  //               const flatSuggestionNames =
  //                 matchingPlan?.accordions?.flatMap(
  //                   (acc) => acc?.suggestions?.suggestionName || []
  //                 ) || [];

  //               const itemStructure = {
  //                 name: suggestion.name,
  //                 suggestions: flatSuggestionNames,
  //               };

  //               collectedPlanSuggestions.push(itemStructure);
  //             }
  //           }

  //           // Recurse children
  //           if (accordion.children && accordion.children.length > 0) {
  //             searchAccordions(accordion.children);
  //           }
  //         }
  //       };

  //       searchAccordions(sugesstionsAssessmentsList || []);
  //       setSelectedPlanSuggestion(collectedPlanSuggestions);
  //     }
  //   }

  //   if (planSuggestionAdded) {
  //     const splittedArrayPlan = planSuggestionAdded.split("\n").filter(Boolean);
  //     console.log(splittedArrayPlan, 'splittedArrayPlan')
  //     setSelectedPlanSuggestionsStrings(splittedArrayPlan);
  //   }
  // }, [noteStructureRef.current, sugesstionsAssessmentsList]);
////new
  // useEffect(() => {
  //   const assessmentSuggestionAdded =
  //     noteStructureRef?.current?.assessment?.[diagnosisName]?.assessmentSuggestions

  //   const planSuggestionAdded =
  //     noteStructureRef?.current?.plans?.[diagnosisName]?.planSuggestion

  //   const selectedAssessmentIds = noteStructureRef?.current?.assessment?.[diagnosisName]?.formattedSelectedSuggestionIdString

  //   if (assessmentSuggestionAdded) {
  //     const assessmentNames = selectedAssessmentIds
  //       .split('\n')
  //       .filter(Boolean)

  //     const restoredAssessmentKeys = []
  //     const collectedPlanSuggestions = []

  //     const searchAccordions = (accordions) => {
  //       for (const accordion of accordions) {
  //         const suggestions = accordion?.suggestions?.suggestionName || []

  //         for (const suggestion of suggestions) {
  //           if (assessmentNames.includes(suggestion.name)) {
  //             // ✅ NEW KEY FORMAT
  //             const suggestionKey = `${accordion.id}-${suggestion.name}`

  //             // prevent duplicates
  //             if (!restoredAssessmentKeys.includes(suggestionKey)) {
  //               restoredAssessmentKeys.push(suggestionKey)

  //               const planSuggestions =
  //                 accordion?.suggestions?.planSuggestions || []

  //               const matchingPlan = planSuggestions.find(
  //                 (plan) => plan.name === suggestion.name
  //               )

  //               const flatSuggestionNames =
  //                 matchingPlan?.accordions?.flatMap(
  //                   (acc) => acc?.suggestions?.suggestionName || []
  //                 ) || []

  //               collectedPlanSuggestions.push({
  //                 key: suggestionKey,
  //                 name: suggestion.name,
  //                 suggestions: flatSuggestionNames,
  //               })
  //             }
  //           }
  //         }

  //         // 🔁 recurse children
  //         if (accordion.children?.length > 0) {
  //           searchAccordions(accordion.children)
  //         }
  //       }
  //     }

  //     searchAccordions(sugesstionsAssessmentsList || [])


  //     console.log("restoredAssessmentKeys", planSuggestionAdded,restoredAssessmentKeys,collectedPlanSuggestions ,assessmentSuggestionAdded,selectedAssessmentIds,)
  //     // ✅ IMPORTANT: set KEYS, not names
  //     setSelectedAssessmentSuggestionString(restoredAssessmentKeys)
  //     setSelectedPlanSuggestion(collectedPlanSuggestions)
  //   }

  //   if (planSuggestionAdded) {
  //     setSelectedPlanSuggestionsStrings(
  //       planSuggestionAdded.split('\n').filter(Boolean)
  //     )
  //   }
  // }, [diagnosisName, sugesstionsAssessmentsList])
useEffect(() => {
  const assessmentSuggestionAdded =
    noteStructureRef?.current?.assessment?.[diagnosisName]
      ?.assessmentSuggestions

  const planSuggestionAdded =
    noteStructureRef?.current?.plans?.[diagnosisName]?.planSuggestion

  const selectedAssessmentIds =
    noteStructureRef?.current?.assessment?.[diagnosisName]
      ?.formattedSelectedSuggestionIdString

  if (selectedAssessmentIds) {
    // 🔑 THESE ARE KEYS, NOT NAMES
    const storedKeys = selectedAssessmentIds
      .split('\n')
      .filter(Boolean)

    const restoredAssessmentKeys = []
    const collectedPlanSuggestions = []

    const searchAccordions = (accordions) => {
      for (const accordion of accordions) {
        const suggestions = accordion?.suggestions?.suggestionName || []

        for (const suggestion of suggestions) {
          // 🔑 RECREATE THE SAME KEY
          const suggestionKey = getSuggestionKey(accordion.id, suggestion)
          const legacySuggestionKey = `${accordion.id}-${suggestion.name}`

          if (storedKeys.includes(suggestionKey) || storedKeys.includes(legacySuggestionKey)) {
            if (!restoredAssessmentKeys.includes(suggestionKey)) {
              restoredAssessmentKeys.push(suggestionKey)

              const matchingPlan =
                accordion?.suggestions?.planSuggestions?.find(
                  (plan) => plan.name === suggestion.name
                )

              const flatSuggestionNames =
                matchingPlan?.accordions?.flatMap(
                  (acc) => acc?.suggestions?.suggestionName || []
                ) || []

              collectedPlanSuggestions.push({
                key: suggestionKey,
                name: suggestion.name,
                suggestions: flatSuggestionNames,
              })
            }
          }
        }

        if (accordion.children?.length > 0) {
          searchAccordions(accordion.children)
        }
      }
    }

    searchAccordions(sugesstionsAssessmentsList || [])

    // ✅ restore exactly what was stored
    setSelectedAssessmentSuggestionString(getDisplayAssessmentKeys(restoredAssessmentKeys))
    setSelectedPlanSuggestion(collectedPlanSuggestions)
    setSelectedId(restoredAssessmentKeys)
  }

  if (planSuggestionAdded) {
    setSelectedPlanSuggestionsStrings(
      planSuggestionAdded.split('\n').filter(Boolean)
    )
  }
}, [diagnosisName, sugesstionsAssessmentsList])



  const getAllDiagnosisDifferential = async () => {



    try {
      const data = await getAssSuggMasterData()
      console.log(" assesment suggection data ", data)
      const findAssessmentSuggestionForDiagnosis = data.find((item) => item?.Data?.diagnosis?.label === diagnosisName)
      console.log(findAssessmentSuggestionForDiagnosis, 'findAssessmentSuggestionForDiagnosis', diagnosisName)
      setSugesstionsAssessmentsList(findAssessmentSuggestionForDiagnosis?.Data?.accordions)
    } catch (err) {
      console.error('Error fetching from IndexedDB:', err)
    }

    // let data = await SaveExtra('Get_By_Type', "AssesmentSuggestions", '', '');
    // data = JSON.parse(data.d)?.Data || [];

    // if (data) {
    //   data = data.map((item) => ({
    //     Id: item.Id,
    //     Data: JSON.parse(item?.JsonData)
    //   }));
    // }

    // const findAssessmentSuggestionForDiagnosis = data.find(
    //   (item) => item?.Data?.diagnosis?.label === diagnosisName
    // );
    // console.log(findAssessmentSuggestionForDiagnosis, 'findAssessmentSuggestionForDiagnosis', diagnosisName)
    // setSugesstionsAssessmentsList(findAssessmentSuggestionForDiagnosis?.Data?.accordions)
  };

  console.log(selectedPlansSuggestionsStrings, 'selectedPlansSuggestionsStrings', diagnosisName)


  useEffect(() => {
    getAllDiagnosisDifferential()
  }, [])


  //   const renderSuggestions = (accordion) => (
  //   <>
  //     {accordion.suggestions?.suggestionName?.map((item, idx) => (
  //       <div
  //         key={idx}
  //         className="d-flex align-items-center gap-2 justify-content-between"
  //       >
  //         <div className="d-flex align-items-center gap-2">
  //           <CFormCheck
  //             className="custom-checkbox"
  //             checked={selectedAssessmentSuggestionStrings.includes(item.name)}
  //             onChange={() => {
  //               const isAlreadySelected =
  //                 selectedAssessmentSuggestionStrings.includes(item.name)
  //                 console.log("selectedAssessmentSuggestionStrings",selectedAssessmentSuggestionStrings , item.name)

  //               if (isAlreadySelected) {
  //                 setSelectedAssessmentSuggestionString((prev) =>
  //                   prev.filter((s) => s !== item.name)
  //                 )
  //                 setSelectedPlanSuggestion((prev) =>
  //                   prev.filter((s) => s.name !== item.name)
  //                 )
  //               } else {
  //                 setSelectedAssessmentSuggestionString((prev) => [
  //                   ...prev,
  //                   item.name,
  //                 ])

  //                 const matchingPlan =
  //                   accordion?.suggestions?.planSuggestions?.find(
  //                     (plan) => plan.name === item.name
  //                   )

  //                 const flatSuggestionNames =
  //                   matchingPlan?.accordions?.flatMap(
  //                     (acc) => acc?.suggestions?.suggestionName || []
  //                   ) || []

  //                 setSelectedPlanSuggestion((prev) => [
  //                   ...prev,
  //                   {
  //                     name: item.name,
  //                     suggestions: flatSuggestionNames,
  //                     description: item.description || '',
  //                   },
  //                 ])
  //               }

  //               console.log("selectedata info" , accordion.suggestions?.suggestionName)
  //             }}
  //             id={`suggestion-${accordion.id}-${idx}`}
  //             label={item.name}
  //           />

  //           {item.description && (
  //             <Info
  //               strokeWidth={1}
  //               size={16}
  //               onClick={() =>
  //                 setShowItemsDescriptions((prev) =>
  //                   prev.includes(`suggestion-${accordion.id}-${idx}`)
  //                     ? prev.filter(
  //                         (id) => id !== `suggestion-${accordion.id}-${idx}`
  //                       )
  //                     : [...prev, `suggestion-${accordion.id}-${idx}`]
  //                 )
  //               }
  //             />
  //           )}
  //         </div>

  //         {showItemsDescriptions.includes(
  //           `suggestion-${accordion.id}-${idx}`
  //         ) && (
  //           <p className="p-0 m-0" style={{ color: 'orange', fontWeight: 600 }}>
  //             {item.description}
  //           </p>
  //         )}
  //       </div>
  //     ))}
  //   </>
  // )

    const [selectedIds, setSelectedId] = useState([])

  const getNextAssessmentSelectionKeys = (currentKeys, key, shouldSelect) => {
    if (!shouldSelect) return currentKeys.filter((item) => item !== key)

    return currentKeys.includes(key) ? [...currentKeys] : [...currentKeys, key]
  }

  const toggleAssessmentKey = (key, shouldSelect) => {
    const nextSelectedKeys = getNextAssessmentSelectionKeys(selectedIds, key, shouldSelect)
    const nextDisplayKeys = getDisplayAssessmentKeys(nextSelectedKeys)

    setSelectedId(nextSelectedKeys)
    setSelectedAssessmentSuggestionString(nextDisplayKeys)
    setSelectedOrder(collectSelectedAssessmentOrderData(sugesstionsAssessmentsList, nextSelectedKeys))
  }

  const renderSuggestions = (accordion) => (
    <>
      {accordion.suggestions?.suggestionName?.map((item, idx) => {
        const suggestionName = getSuggestionText(item)
        const suggestionKey = getSuggestionKey(accordion.id, item)

        console.log("itemData", item, accordion)

        return (
          <div
            key={suggestionKey}
            className="d-flex align-items-center gap-2 justify-content-between"
          >
            <div className="d-flex align-items-center gap-2">
              <CFormCheck
                className="custom-checkbox"
                checked={selectedAssessmentSuggestionStrings.includes(suggestionKey)}
                onChange={() => {
                  const isAlreadySelected =
                    selectedIds.includes(suggestionKey)

                  if (isAlreadySelected) {
                    toggleAssessmentKey(suggestionKey, false)

                    setSelectedPlanSuggestion((prev) =>
                      prev.filter((s) => s.key !== suggestionKey)
                    )
                  } else {
                    toggleAssessmentKey(suggestionKey, true)

                    const matchingPlan =
                      accordion?.suggestions?.planSuggestions?.find(
                        (plan) => getSuggestionText(plan) === suggestionName
                      )

                    const flatSuggestionNames =
                      matchingPlan?.accordions?.flatMap(
                        (acc) => acc?.suggestions?.suggestionName || []
                      ) || []


                    setSelectedPlanSuggestion((prev) => [
                      ...prev,
                      {
                        id :  accordion.id,
                        key: suggestionKey,
                        name: suggestionName,
                        suggestions: flatSuggestionNames,
                        description: item.description || '',
                      },

                    ])
                  }
                }}
                id={`suggestion-${suggestionKey}`}
                label={suggestionName}
              />

              {item.description && (
                <Info
                  strokeWidth={1}
                  size={16}
                  onClick={() =>
                    setShowItemsDescriptions((prev) =>
                      prev.includes(`suggestion-${suggestionKey}`)
                        ? prev.filter(
                          (id) => id !== `suggestion-${suggestionKey}`
                        )
                        : [...prev, `suggestion-${suggestionKey}`]
                    )
                  }
                />
              )}
            </div>

            {showItemsDescriptions.includes(
              `suggestion-${suggestionKey}`
            ) && (
                <p className="p-0 m-0" style={{ color: 'orange', fontWeight: 600 }}>
                  {item.description}
                </p>
              )}
          </div>
        )
      })}
    </>
  )

console.log("selectedOrderData",selectedOrder)

  useEffect(() => {
    setSelectedOrder(collectSelectedAssessmentOrderData(sugesstionsAssessmentsList, selectedIds))
  }, [sugesstionsAssessmentsList, selectedIds])

  const renderNestedAccordions = (accordions) => {
    return (
      <div className={`${role == 'provider' ? 'accordion-dark' : ' '}  `}>
        <CAccordion className="transparentAccordion">
          {accordions.map((accordion, index) => {
            const hasTitle = accordion?.title && accordion.title.trim() !== ''
            const titleKey = getTitleKey(accordion.id)
            const isTitleSelected = selectedAssessmentSuggestionStrings.includes(titleKey)

            return hasTitle ? (

              <CAccordionItem
                className="mt-2"
                itemKey={accordion.id || index}
                key={accordion.id || index}
              >
                <CAccordionHeader>
                  <div className="gap-2 d-flex align-items-center">
                    <CFormCheck
                      className="mb-0"
                      id={`title-${titleKey}`}
                      checked={isTitleSelected}
                      onMouseDown={(event) => event.stopPropagation()}
                      onClick={(event) => event.stopPropagation()}
                      onChange={() => {
                        const shouldSelect = !selectedIds.includes(titleKey)
                        toggleAssessmentKey(titleKey, shouldSelect)
                      }}
                    />
                    {accordion?.description && (
                      <CTooltip content={accordion.description}>
                        <Info strokeWidth={1} size={16} />
                      </CTooltip>
                    )}
                    {accordion.title}
                  </div>
                </CAccordionHeader>

                <CAccordionBody>
                  {accordion.children?.length > 0
                    ? renderNestedAccordions(accordion.children)
                    : <>
                      {renderSuggestions(accordion)}
                      {/* {renderOrdersData(accordion)} */}
                    </>}
                </CAccordionBody>
              </CAccordionItem>
            ) : (

              <div key={accordion.id || index}>
                {accordion.children?.length > 0
                  ? renderNestedAccordions(accordion.children)
                  : <>
                    {renderSuggestions(accordion)}
                    {/* {renderOrdersData(accordion)} */}
                  </>}
              </div>
            )
          })}
        </CAccordion>

      </div>
    )
  };

  const renderAccordions = () => {
    if (sugesstionsAssessmentsList?.length) {
      return renderNestedAccordions(sugesstionsAssessmentsList);
    }
    return null;
  };

  // useEffect(() => {
  //   setAssessmentFinalValue(selectedAssessmentSuggestionStrings.join("\n"))
  // }, [selectedAssessmentSuggestionStrings])
  const getAssessmentTextFromKeys = (accordions, selectedKeys) => {
    const selectedKeySet = new Set(Array.isArray(selectedKeys) ? selectedKeys : [])
    const lines = []

    const visit = (items) => {
      for (const accordion of Array.isArray(items) ? items : []) {
        if (selectedKeySet.has(getTitleKey(accordion?.id)) && accordion?.title) {
          lines.push(accordion.title)
        }

        const suggestions = Array.isArray(accordion?.suggestions?.suggestionName)
          ? accordion.suggestions.suggestionName
          : []

        suggestions.forEach((suggestion) => {
          if (selectedKeySet.has(getSuggestionKey(accordion?.id, suggestion))) {
            lines.push(getSuggestionText(suggestion))
          }
        })

        visit(accordion?.children)
      }
    }

    visit(accordions)
    return lines.join('\n')
  }

  useEffect(() => {
    setAssessmentFinalValue(getAssessmentTextFromKeys(sugesstionsAssessmentsList, selectedAssessmentSuggestionStrings))
  }, [selectedAssessmentSuggestionStrings, sugesstionsAssessmentsList])


  const handleAddToOfflineAssessmentSuggestion = async (selectedPlansSuggestionsStrings, assessmentFinalValue, formattedSelectedPlanSuggestionsStrings) => {
    try {
      let dataOffline = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
      if (dataOffline) {
        console.log('offlineData before adding assess:', dataOffline);
        dataOffline = {
          ...dataOffline,
          [loggedUserProvider?.ID]: {
            ...dataOffline[loggedUserProvider?.ID],
            [patientID]: {
              ...dataOffline[loggedUserProvider?.ID][patientID],
              currentNote: {
                ...dataOffline[loggedUserProvider?.ID][patientID].currentNote,
                data: {
                  ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data,
                  plans: {
                    ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.plans,
                    [diagnosisName]: {
                      ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.plans?.[diagnosisName],
                      planSuggestion: selectedPlansSuggestionsStrings,
                      formattedSelectedPlanSuggestionsStrings: formattedSelectedPlanSuggestionsStrings,
                    }
                  },
                  assessment: {
                    ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.assessment,
                    [diagnosisName]: {
                      ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.assessment?.[diagnosisName],
                      assessmentSuggestions: assessmentFinalValue,
                      formattedSelectedSuggestionIdString : selectedIds.join("\n")
                    }
                  }
                }
              },
              saveDraft: true
            }
          }
        }
      }
      console.log('offlineData after adding assess:', dataOffline);
      noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(dataOffline) : await saveOfflineData(dataOffline)

    } catch (error) {
      console.log(error, 'error adding assess')
    }
  }

  const handleSubmitModal = async () => {
    console.log(selectedAssessmentSuggestionStrings.join("\n"), 'selectedAssessmentSuggestionStrings.join("\n")')
    console.log(selectedPlansSuggestionsStrings.join("\n"), "selectedPlansSuggestionsStrings.join()")

    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment?.[diagnosisName],
          assessmentSuggestions: assessmentFinalValue,
        formattedSelectedSuggestionIdString : selectedIds.join("\n")
        }
      },
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef.current.plans[diagnosisName],
          planSuggestion: selectedPlansSuggestionsStrings.join("\n"),
          formattedSelectedPlanSuggestionsStrings: formattedSelectedPlanSuggestionsStrings,
           
        }
      }
    }

    console.log("selecteStrings", selectedPlansSuggestionsStrings, assessmentFinalValue)
    await handleAddToOfflineAssessmentSuggestion(selectedPlansSuggestionsStrings.join("\n"), assessmentFinalValue, formattedSelectedPlanSuggestionsStrings)
    setAssessmentSuggestions(assessmentFinalValue)
    setVisible(false)
    setAddedChangesToAssessment(p => !p)
    setShowItemsDescriptions([])
    // saveTreatsShell(false)
    console.log(noteStructureRef.current, 'noteStructureRef.current')

  }
  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  useEffect(() => {
    // keep the notestructure back to states
    const assessmentFinalValueInNoteStructure = noteStructureRef.current?.assessment?.[diagnosisName]?.assessmentSuggestions
    const planSuggestionInNoteStructure = noteStructureRef.current?.plans?.[diagnosisName]?.planSuggestion
    const formattedSelectedPlanSuggestionsStringss = noteStructureRef.current?.plans?.[diagnosisName]?.formattedSelectedPlanSuggestionsStrings

    if (assessmentFinalValueInNoteStructure) {
      setAssessmentSuggestions(assessmentFinalValueInNoteStructure)
    }


    if (planSuggestionInNoteStructure) {
      setSelectedPlanSuggestionsStrings(planSuggestionInNoteStructure.split("\n"))
    }

    if (formattedSelectedPlanSuggestionsStringss) {
      setFormattedSelectedPlanSuggestionsStrings(formattedSelectedPlanSuggestionsStringss)
    }
  }, [])


  //   useEffect(() => {
  //   const assessmentFinalValueInNoteStructure =
  //     noteStructureRef.current?.assessment?.[diagnosisName]?.assessmentSuggestions

  //   const planSuggestionInNoteStructure =
  //     noteStructureRef.current?.plans?.[diagnosisName]?.planSuggestion

  //   const formattedSelectedPlanSuggestionsStringss =
  //     noteStructureRef.current?.plans?.[diagnosisName]?.formattedSelectedPlanSuggestionsStrings


  //   if (assessmentFinalValueInNoteStructure) {
  //     const restoredKeys = []

  //     sugesstionsAssessmentsList.forEach((accordion) => {
  //       accordion?.suggestions?.suggestionName?.forEach((item) => {
  //         if (assessmentFinalValueInNoteStructure.includes(item.name)) {
  //           restoredKeys.push(`${accordion.id}-${item.name}`)
  //         }
  //       })
  //     })

  //     setSelectedAssessmentSuggestionString(restoredKeys)
  //   }


  //   if (planSuggestionInNoteStructure) {
  //     setSelectedPlanSuggestionsStrings(
  //       planSuggestionInNoteStructure.split('\n')
  //     )
  //   }

  //   if (formattedSelectedPlanSuggestionsStringss) {
  //     setFormattedSelectedPlanSuggestionsStrings(
  //       formattedSelectedPlanSuggestionsStringss
  //     )
  //   }
  // }, [])


  console.log("selectedSuggestions", selectedPlanSuggestion, sugesstionsAssessmentsList)

  return (
    <>
      <CAccordionItem className="border">
        <CAccordionHeader>
          <div className="d-flex align-items-center gap-2 w-100">
            <h7>Assessment</h7>
            <CFormLabel
              className="d-flex text-white flex-column align-items-center mt-2 justify-content-center shadow "
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                setActiveTabPatientInfo(26)
              }}
              style={{
                fontWeight: '300',
                fontSize: '14px',
                width: '30px',
                height: '30px',
                borderRadius: '20px',
                background: '#4363F2',
                cursor: 'pointer',
              }}
            >
              <span>E</span>
            </CFormLabel>
          </div>
        </CAccordionHeader>
        <CAccordionBody>
          <div style={{ background: '#252525' }}>
            {/* <div className='d-flex align-items-center gap-1'>
                    <h7><b>Assessment</b></h7>
                </div> */}
            {/* <hr /> */}
            <div className="">
              {showTreatmentAsAccordion && (
                <h7 style={{ fontSize: '14px' }}>
                  <b>Assessment</b>
                </h7>
              )}
            </div>

            {isTextInput ? (
              <div>
                {poa && (
                  <p>
                    <strong className="text-white fw-semibold">POA</strong>: {poa}
                  </p>
                )}
                {assessment && (
                  <p>
                    {' '}
                    <strong className="text-white fw-semibold">Assessment</strong>: {assessment}
                  </p>
                )}
                {freeType && (
                  <p>
                    <strong className="text-white fw-semibold">Free Type</strong>: {freeType}
                  </p>
                )}
              </div>
            ) : (
              <div className="p-4" style={{ background: '#252525' }}>
                {/* <div className="mb-4">
                            <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>POA</label>
                            <CFormTextarea
                                className="bg-secondary border rounded shadow-sm mt-2"
                                rows={3}
                                value={poa}
                                onChange={(e) => { handlePoaChange(e.target.value) }}
                            />
                        </div> */}

                {
                  <div className="mb-4">
                    {/* <label className="text-white fw-semibold" style={{ fontSize: '14px' }}>
                        Labs & Imaging
                      </label> */}
                    {/* <CFormTextarea placeholder="No Labs & Imaging" className="     mt-2 text-white" style={{ background: '#252525', border: '1px solid gray ' , height:'200px' }} rows={5} value={assessment} onChange={(e) => handleLabsChanges(e.target.value)} /> */}
                    <div className="mb-4">
                      <label className="text-white fw-semibold" style={{ fontSize: '14px' }}>
                        Labs & Imaging
                      </label>
                      <div
                        style={{
                          minHeight: '40px',
                          padding: '8px',
                          backgroundColor: '#282828',
                          color: '#fff',
                          borderRadius: '4px',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                          border: '1px solid gray ',
                          marginTop: '10px',
                        }}
                      >
                        {assessment || (
                          <span className="" style={{ color: '#989898' }}>
                            No Labs & Imaging
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {
                  // <div className="mb-4">
                  //   <div className="d-flex align-items-center gap-1">
                  //     <label className="text-white fw-semibold" style={{ fontSize: '14px' }}>
                  //       Assessment Suggestions
                  //     </label>
                  //     {/* {isAllotedToProvider && <CFormLabel
                  //                         className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
                  //                         onClick={() => setVisible((p) => !p)}
                  //                         style={{
                  //                             width: "30px",
                  //                             height: "30px",
                  //                             borderRadius: "20px",
                  //                             background: "#7B8BE7",
                  //                             cursor: "pointer",
                  //                         }}
                  //                     >
                  //                         <Plus className="text-white" strokeWidth={2} size={15} />
                  //                     </CFormLabel>} */}
                  //   </div>
                  //   <CFormTextarea placeholder="Add Assessment Suggestion" style={{ background: '#252525', border: '1px solid gray' }} onClick={() => setVisible((p) => !p)} className="   mt-2 text-white" rows={5} value={assessmentSuggestions} onChange={(e) => handleLabsChanges(e.target.value)} />
                  // </div>
                }
                <div className="mb-4">
                  <div className="d-flex align-items-center gap-1">
                    <label className="text-white fw-semibold" style={{ fontSize: '14px' }}>
                      Assessment Suggestions
                    </label>
                  </div>

                  <div
                    style={{
                      minHeight: '40px',
                      padding: '10px',
                      background: '#252525',
                      border: '1px solid gray',
                      borderRadius: '4px',
                      color: 'white',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                      cursor: 'pointer',
                      marginTop: '8px',
                    }}
                    onClick={() => setVisible((p) => !p)}
                  >
                    {assessmentSuggestions || <span style={{ color: '#989898' }}>No suggestions </span>}
                  </div>
                </div>

                {/* {diagnosisName === 'Cognitive Communication Deficit' && bimsScoreData && bimsScoreData.date && bimsScoreData.score && <div className="mb-4">
                            <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>Bims Score</label>
                            <CFormTextarea
                                className="bg-secondary border rounded shadow-sm mt-2"
                                rows={3}
                                disabled
                                value={bimsScoreData && bimsScoreData.date && bimsScoreData.score && `Bims Score: ${bimsScoreData.score}   recorded on Date: ${new Date(bimsScoreData.date).toLocaleDateString('en-US')}`}
                            />
                        </div>} */}
                {/* <div>
                    <label className="text-white fw-semibold" style={{ fontSize: '14px' }}>
                      Free Type
                    </label>
                    <Graytextarea
                      height="100px"
                      value={freeType}
                      style={{
                        minHeight:'50px',
                        color: 'white',
                        backgroundColor: '#282828',
                        border: '1px solid #989898',
                        marginTop: '10px',
                      }}
                      onClick={() => {
                        setTempText(freeType)
                        setIsFreeModalVisible(true)
                      }}
                    />
                  </div> */}
                <div>
                  <label className="text-white fw-semibold" style={{ fontSize: '14px' }}>
                    Free Type
                  </label>
                  <div
                    style={{
                      minHeight: '50px',
                      fontSize: '14px',
                      color: 'white',
                      backgroundColor: '#282828',
                      border: '1px solid #989898',
                      marginTop: '10px',
                      padding: '10px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      whiteSpace: 'pre-line',
                    }}
                    onClick={() => {
                      setTempText(freeType)
                      setIsFreeModalVisible(true)
                    }}
                  >
                    {freeType || (
                      <span
                        style={{
                          fontSize: '14px',
                          color: '#989898',
                        }}
                      >
                        Enter Free Type
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </CAccordionBody>
      </CAccordionItem>

      <CModal className="modal-assessment" visible={visible} onClose={() => setVisible(false)} aria-labelledby="ToggleBetweenModalsExample1">
        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
          }}
          className="order-tabs my-custom-tabs"
        >
          <div className="d-flex align-items-center gap-2 justify-content-center">
            <div
              onClick={() => setActiveKey(1)}
              style={{
                cursor: 'pointer',
                width: '250px',
                textAlign: 'center',
                borderRadius: '6px',
                padding: '8px',
                backgroundColor: activeKey === 1 ? '#4363F2' : '#282828',
                border: '1px solid gray',
                color: activeKey === 1 ? 'white' : '#bbb',
                transition: 'background-color 0.3s ease, color 0.3s ease',
              }}
            >
              Suggestion
            </div>

            <div
              onClick={() => setActiveKey(2)}
              style={{
                cursor: 'pointer',
                width: '250px',
                textAlign: 'center',
                borderRadius: '6px',
                padding: '8px',
                backgroundColor: activeKey === 2 ? '#4363F2' : '#282828',
                border: '1px solid gray',
                color: activeKey === 2 ? 'white' : '#bbb',
                transition: 'background-color 0.3s ease, color 0.3s ease',
              }}
            >
              Assessment
            </div>
          </div>

          <CTabContent>
            <CTabPane role="tabpanel" aria-labelledby="home-tab" className="mt-2" visible={activeKey === 1}>
              <CContainer
                className="p-0 border m-0 w-100"
                style={{
                  maxWidth: '100%',
                  height: '70vh',
                  overflowY: 'scroll',
                  borderRadius: '10px',
                }}
              >
                <CRow className="statement-btn-div">
                  <CCol
                    style={{
                      cursor: 'pointer',
                      width: '250px',
                      textAlign: 'center',
                      borderRadius: '6px',
                      // padding: '8px',
                      marginLeft: "20px"
                    }}
                    className="w-50 p-4"
                  >
                    <div>{sugesstionsAssessmentsList && sugesstionsAssessmentsList?.length > 0 ? renderAccordions() : <div> No Suggestions Available </div>}</div>
                  </CCol>

                  <CCol
                    style={{
                      width: '50%',
                      height: '70vh',
                    }}
                    className="w-50"
                  >
                    <p className="text-center p-2 mb-0 fw-bold">Add to plan</p>
                    <div className="d-flex align-items-center gap-2 justify-content-center">
                      <CButton
                        variant="outline"
                        onClick={() => {
                          setActiveKey2(1)
                          setOrderModalVisible(true)
                        }}
                        style={{
                          backgroundColor: activeKey2 === 1 ? '#4363F2' : 'transparent',
                          border: activeKey2 === 1 ? 'none' : '1px solid gray',
                          color: activeKey2 === 1 ? 'white' : '#4363F2',
                          borderRadius: '6px',
                          padding: '8px 20px',
                          cursor: 'pointer',
                          boxShadow: 'none',
                        }}
                      >
                        <span className="text-white">Orders</span>
                      </CButton>
                      <CButton
                        active={activeKey2 === 2}
                        onClick={() => setActiveKey2(2)}
                        style={{
                          backgroundColor: activeKey2 === 2 ? '#4363F2' : 'transparent',
                          border: activeKey2 === 2 ? 'none' : '1px solid gray',
                          color: activeKey2 === 2 ? 'white' : '#4363F2',
                          borderRadius: '6px',
                          padding: '8px 20px',
                          cursor: 'pointer',
                          boxShadow: 'none',
                        }}
                      >
                        <span className="text-white">Statements</span>
                      </CButton>
                    </div>
                    {/* <CNav className='d-flex align-items-center gap-2' variant="pills" >
                                            <CNavItem className=''>
                                                <CNavLink
                                                    
                                                >
                                                    <CButton>
                                                        Orders
                                                    </CButton>
                                                </CNavLink>
                                            </CNavItem>
                                            <CNavItem className=''>
                                                <CNavLink
                                                    
                                                >
                                                    Suggestions
                                                </CNavLink>
                                            </CNavItem>
                                        </CNav> */}

                    <CTabContent>
                      <CTabPane role="tabpanel" aria-labelledby="home-tab" className="mt-2 " style={{ marginRight: "40px" }} visible={activeKey2 === 2}>
                        <div className={`  ${role == 'provider' ? 'accordion-dark' : ' '}  `}>
                          {selectedPlanSuggestion.map((item, idx) => {

                            console.log("item", item)
                            return (
                              <CAccordion flush className="transparentAccordion">
                                <CAccordionItem className="mt-2" itemKey={1}>
                                  <CAccordionHeader className="" style={{ fontSize: '10px' }}>
                                    <div className="d-flex align-items-center gap-2">
                                      {item?.description && item?.description !== '' && (
                                        <CTooltip content={item?.description ? item?.description : 'Add the tooltip'}>
                                          <Info strokeWidth={1} size={16} />
                                        </CTooltip>
                                      )}
                                      {item.name}
                                    </div>
                                  </CAccordionHeader>
                                  <CAccordionBody>
                                    <div>
                                      {
                                        item?.suggestions && item?.suggestions.length > 0 &&
                                        item?.suggestions.map((listItem, idx) => {
                                          const suggestionText = listItem.name || listItem;
                                          const uniqueValue = `${item.name}::${listItem.name || listItem}`;
                                          return (
                                            <CFormCheck
                                              className="custom-checkbox"
                                              onChange={() => {


                                                if (selectedPlansSuggestionsStrings.includes(suggestionText)) {
                                                  setSelectedPlanSuggestionsStrings((prev) =>
                                                    prev.filter((s) => s !== suggestionText)
                                                  )
                                                } else {
                                                  setSelectedPlanSuggestionsStrings((prev) =>
                                                    [...prev, suggestionText]
                                                  )
                                                }
                                                if (formattedSelectedPlanSuggestionsStrings.includes(uniqueValue)) {
                                                  setFormattedSelectedPlanSuggestionsStrings((prev) =>
                                                    prev.filter((s) => s !== uniqueValue)
                                                  )
                                                }
                                                else {
                                                  setFormattedSelectedPlanSuggestionsStrings((prev) =>
                                                    [...prev, uniqueValue]
                                                  )
                                                }

                                                console.log("data found", formattedSelectedPlanSuggestionsStrings, selectedPlansSuggestionsStrings, suggestionText)
                                              }}
                                              id={`${item.name}::${listItem.name}`}
                                              checked={formattedSelectedPlanSuggestionsStrings.includes(uniqueValue)}
                                              label={listItem?.name || listItem}
                                            />
                                          )
                                        })}
                                    </div>
                                  </CAccordionBody>
                                </CAccordionItem>
                              </CAccordion>
                            )
                          })}
                        </div>
                      </CTabPane>
                    </CTabContent>
                  </CCol>
                </CRow>
              </CContainer>
            </CTabPane>
            <CTabPane role="tabpanel" aria-labelledby="profile-tab" visible={activeKey === 2}>
              <Graytextarea onChange={(e) => setAssessmentFinalValue(e.target.value)} value={assessmentFinalValue} />
            </CTabPane>
          </CTabContent>
        </CModalBody>
        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
          }}
          className="justify-content-center pt-2"
        >
          <CButton
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
              widht: '200px',
            }}
            variant="outline"
            onClick={() => {
              setVisible(false)
              // setSelectedPlanSuggestion([])
              setShowItemsDescriptions([])
            }}
            color="secondary"
          >
            Close
          </CButton>
          <CButton
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
              widht: '200px',
            }}
            variant="outline"
            onClick={() => {
              setSelectedPlanSuggestion([])
              setSelectedAssessmentSuggestionString([])
              setSelectedOrder([])
              setAssessmentFinalValue('')
              setSelectedPlanSuggestionsStrings([])
              setSelectedId([])
              setShowItemsDescriptions([])
            }}
            color="secondary"
          >
            Clear All
          </CButton>
          <CButton
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
              width: '200px',
            }}
            onClick={handleSubmitModal}
          >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" backdrop="static" visible={orderModalVisible} onClose={() => setOrderModalVisible(false)} aria-labelledby="StaticBackdropExampleLabel">
        <FetchOrderForAssessment
          patientID={patientID}
          noteID={noteID}
          diagnosisName={diagnosisName}
          toggleModal={() => {
            setOrderModalVisible((p) => !p)
            setActiveKey2(1)
          }}
          fetchOrdersAgain={() => { }}
          noteCallType={noteCallType}
          patientDBData={patientDBData}
          setPatientDBData={setPatientDBData}
          selectedOrder={selectedOrder}

        />
      </CModal>

      <CModal visible={freeModelVisible} onClose={() => setIsFreeModalVisible(false)} size="lg" alignment="center">
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '10px 10px 0 0',
          }}
          closeButton
        >
          <CModalTitle
            style={{
              color: 'white',
              textAlign: 'center',
              width: '100%',
            }}
          >
            Free Type
          </CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <Graytextarea style={{ color: 'white', background: '#252525', border: '1px solid gray', height: '200px' }} value={tempText} onChange={(e) => setTempText(e.target.value)} rows={5} />
        </CModalBody>
        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
            borderRadius: '0 0 10px 10px',
          }}
        >
          <CButton
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            color="primary"
            onClick={handleSave}
          >
            Save
          </CButton>
          <CButton
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            color="secondary"
            onClick={() => setIsFreeModalVisible(false)}
          >
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
};

export default ProviderShellAssessment;
